import atomize from "@quarkly/atomize";
import { commonTextProps, commonTextPropsDefaults } from "./text";
var config = {
  name: "Strong",
  normalize: true,
  mixins: true,
  description: {
    en: "Strong text",
    ru: "Strong text"
  },
  propInfo: commonTextProps
};
export var Strong = atomize.strong(config, commonTextPropsDefaults);
export var B = atomize.b(config, commonTextPropsDefaults);